module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-15.70056e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-15.jpg
// module id = uCtE
// module chunks = 52